import React from "react";
var __jsx = React.createElement;
import getBestMedia from '@anm/helpers/getBestMedia';
import { isVideoBlocked } from '@anm/hosting-player';
import { useEffect } from 'react';

var PlayerContainer = function PlayerContainer(_ref) {
  var target = _ref.target,
      videoId = _ref.videoId,
      manifest = _ref.manifest,
      startTime = _ref.startTime,
      onPlayerInit = _ref.onPlayerInit,
      playerContainerRef = _ref.playerContainerRef;
  var bestVideo = manifest && !isVideoBlocked(manifest) && getBestMedia(manifest.main, 'video');
  useEffect(function () {
    window.onPlayerInit = onPlayerInit;
  }, []);

  var _ref2 = bestVideo || {},
      width = _ref2.width,
      height = _ref2.height;

  return __jsx("div", {
    ref: playerContainerRef,
    className: "wave_embed",
    "data-id": videoId,
    "data-width": width,
    "data-height": height,
    "data-target": target,
    "data-time": startTime,
    "data-manifest": JSON.stringify(manifest)
  });
};

export default PlayerContainer;